export default function() {
  return {
    items: [],
    itemsMspns: [],
    pagination: [],
    item: {}
  }
}